import { useEffect, useState } from 'react';

export function useFTUESeen(key = 'ftue-seen') {
  const [seen, setSeen] = useState<boolean | null>(null);
  const [ready, setReady] = useState(false);
  useEffect(() => {
    try {
      const value = localStorage.getItem(key);
      setSeen(value === 'true');
    } finally {
      setReady(true);
    }
  }, [key]);

  const markSeen = () => {
    localStorage.setItem(key, 'true');
    setSeen(true);
  };

  return { seen, markSeen, ready };
}
